import React from 'react';
import { Route } from 'react-router-dom';

class ButtonArea extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      areaBottomPos: {}
    };
    this.timer = null;
  }

  handleGoBack(history) {
    let phase = this.props.state.phase,
        newPhase = phase - 1;
    if(phase > 1) {
      this.props.updateState({phase: newPhase});
      history.push(this.props.state.phases[newPhase - 1].path);
    }
  }

  renderBackButton(history) {
    return (this.props.state.phase !== 1) ?
      <button id="previous" onClick={() => {
        this.handleGoBack(history);
        window.scrollTo(0,0);
      }}>Palaa edelliseen vaiheeseen</button> :
      null;
  }

  renderNextButton(history) {
    let nextPhaseId = this.props.state.phase + 1;
    let nextPhasePath = this.props.state.phases[nextPhaseId - 1] ? this.props.state.phases[nextPhaseId - 1].path : "/";
    let disabled = true;
    if (this.props.state.phase === 1) {
      disabled = (this.props.state.implementationModel === null);
    } else if (this.props.state.phase === 2) {
      disabled = (this.props.state.selectedFundings.length === 0);
    } else if (this.props.state.phase === 3) {
      disabled = false;
    }
    return (<button id="continue"
      disabled={disabled}
      onClick={() => {
        this.props.updateState({phase: nextPhaseId});
        history.push(nextPhasePath);
        window.scrollTo(0,0);
      }}>Jatka</button>);
  }

  inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
  }

  render() {
    return (
      <div className="button-area App">
        <div className="App-wrapper">
            <Route render={({history}) => (
              <div className="main-col">
                {this.renderBackButton(history)}
                {this.renderNextButton(history)}
              </div>
            )} />
        </div>
      </div>
    );
  }
}

export default ButtonArea;
